import { IAction } from "../utils";
import { reducerTypes } from "./types";
import { IPageInfo } from "../../interfaces/common";
import { IContactUs } from "../../interfaces/contactUs";

export interface IContactUsReducer {
  pageInfo: IPageInfo;
  contactUsAll: IContactUs[];
  сontactUsMore: IContactUs[];
  contactUs?: IContactUs;
  loading: boolean;
}

export const INITIAL: IContactUsReducer = {
  pageInfo: {
    pageIndex: -1,
    totalPages: 0,
    totalCount: 0,
    pageSize: 12,
  },
  contactUsAll: [],
  сontactUsMore: [],
  loading: false,
};

export const ContactUsReducer = (state = INITIAL, { type, payload }: IAction) => {
  switch (type) {
    case reducerTypes.IS_LOADING:
      return { ...state, loading: payload };
    case reducerTypes.GET_ALL_CONTACTUS:
      return {
        ...state,
        contactUsAll: payload,
        сontactUsMore: payload,
        loading: false,
      };
    case reducerTypes.GET_MORE_CONTACTUS:
      return {
        ...state,
        сontactUsMore: [...state.сontactUsMore, ...payload],
        loading: false,
      };
    case reducerTypes.GET_CONTACTUS:
      return { ...state, contactUs: payload };
    case reducerTypes.SET_PAGE_INFO:
      return { ...state, pageInfo: payload };
    case reducerTypes.SET_PAGE_INDEX:
      return { ...state, pageInfo: { ...state.pageInfo, pageIndex: payload } };
    case reducerTypes.SET_PAGE_SIZE:
      return { ...state, pageInfo: { ...state.pageInfo, pageSize: payload } };
    default:
      return state;
  }
};
